export const enum DayOfWeek {
  Monday = 'monday',
  Tuesday = 'tuesday',
  Wednesday = 'wednesday',
  Thursday = 'thursday',
  Friday = 'friday',
  Saturday = 'saturday',
  Sunday = 'sunday',
}

export type TimeRange = [string, string]
export type ScheduleProps = Record<DayOfWeek, TimeRange[]>

interface DaySchedule {
  label: DayOfWeek
  range: string
  rangeList: string[]
}

class Schedule {
  public readonly days: Map<DayOfWeek, TimeRange[]> = new Map()

  constructor(schedule: ScheduleProps) {
    Object.entries(schedule).forEach(([day, timeRanges]) => {
      this.days.set(day as DayOfWeek, timeRanges)
    })
  }

  getDaySchedule(day: DayOfWeek): string[] {
    const timeRanges = this.days.get(day) || []
    return timeRanges.map(([start, end]) => `${start} - ${end}`)
  }
}

export default class ScheduleHours {
  public readonly schedule: Schedule

  constructor(schedule: ScheduleProps) {
    this.schedule = new Schedule(schedule)
  }

  getTodaySchedule(): string {
    const today = new Date()
      .toLocaleDateString('en-US', { weekday: 'long' })
      .toLowerCase() as DayOfWeek
    return this.schedule.getDaySchedule(today).join(' | ')
  }

  getScheduleList(): DaySchedule[] {
    return [
      DayOfWeek.Monday,
      DayOfWeek.Tuesday,
      DayOfWeek.Wednesday,
      DayOfWeek.Thursday,
      DayOfWeek.Friday,
      DayOfWeek.Saturday,
      DayOfWeek.Sunday,
    ].map((day) => {
      return {
        label: day,
        range: this.schedule.getDaySchedule(day).join(' | '),
        rangeList: this.schedule.getDaySchedule(day),
      }
    })
  }
}

export const ScheduleHoursDefaults = new Map<string, ScheduleProps>([
  [
    'always_open',
    {
      [DayOfWeek.Monday]: [['00:00', '23:59']],
      [DayOfWeek.Tuesday]: [['00:00', '23:59']],
      [DayOfWeek.Wednesday]: [['00:00', '23:59']],
      [DayOfWeek.Thursday]: [['00:00', '23:59']],
      [DayOfWeek.Friday]: [['00:00', '23:59']],
      [DayOfWeek.Saturday]: [['00:00', '23:59']],
      [DayOfWeek.Sunday]: [['00:00', '23:59']],
    },
  ],
  [
    'weekdays',
    {
      [DayOfWeek.Monday]: [['09:00', '18:00']],
      [DayOfWeek.Tuesday]: [['09:00', '18:00']],
      [DayOfWeek.Wednesday]: [['09:00', '18:00']],
      [DayOfWeek.Thursday]: [['09:00', '18:00']],
      [DayOfWeek.Friday]: [['09:00', '18:00']],
      [DayOfWeek.Saturday]: [],
      [DayOfWeek.Sunday]: [],
    },
  ],
  [
    'everyday',
    {
      [DayOfWeek.Monday]: [['09:00', '18:00']],
      [DayOfWeek.Tuesday]: [['09:00', '18:00']],
      [DayOfWeek.Wednesday]: [['09:00', '18:00']],
      [DayOfWeek.Thursday]: [['09:00', '18:00']],
      [DayOfWeek.Friday]: [['09:00', '18:00']],
      [DayOfWeek.Saturday]: [['09:00', '18:00']],
      [DayOfWeek.Sunday]: [['09:00', '18:00']],
    },
  ],
])
